import { ChangeEvent, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@mui/material';

import { RequiredLabel } from 'main/components/_common/RequiredLabel';
import { changeName } from 'main/store/contact/reducer';
import { selectNameFormValue } from 'main/store/contact/selectors';

export const NameTextField = () => {
    const dispatch = useDispatch();
    const { value, errors } = useSelector(selectNameFormValue);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeName(event.target.value));
    }, [dispatch]);

    return (
        <TextField
            data-testid="contact-name-text-field"
            fullWidth
            label={<RequiredLabel label="お名前" />}
            value={value}
            error={errors.length > 0}
            helperText={errors.join('\n')}
            onChange={handleChange}
        />
    )
}
